import { useRef, useState } from 'react'
import { ISessionUseRepeatVideosState } from '../types'
import { IVideoTypedAsset } from '../../modules/videos/types'

const useRepeatVideos: ISessionUseRepeatVideosState = () => {
  const [showRepeatVideos, setShowRepeatVideos] = useState<boolean>(false)
  const repeatVideosRef = useRef<Array<IVideoTypedAsset>>([])

  return { showRepeatVideos, setShowRepeatVideos, repeatVideosRef } as const
}

export default useRepeatVideos
